var __rspack_ns_object = JSON.parse('{"totalBalance":"15000.50","totalUnpaidEarnings":"250.75","totalEarnedAmount":"1250.25","currency":"USDC"}')